import React, { Suspense, useEffect } from 'react'
import { Route, Switch, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import routes from './routesList'
import RouteValidator from './RouteValidator'
import NotFoundComponent from 'components/layout/404/index'
import Header from 'components/layout/Header/index'
import { LOADER_HANDLER_TYPES, ROUTE_PATHS } from 'constants/index'
// import MainLoader from 'components/ui-kit/Loader/MainLoader/index'
import Loader from 'components/ui-kit/Loader/index'
import OnramperWidget from 'components/layout/OnramperWidget'

const isPredictionMarketPath = (pathname = '') =>
  pathname === ROUTE_PATHS.predictionMarket ||
  pathname.startsWith(`${ROUTE_PATHS.predictionMarket}/`)

const CustomRoutes = () => {
  const { pathname } = useLocation()
  const isPredictionMarket = isPredictionMarketPath(pathname)
  const { [LOADER_HANDLER_TYPES.page]: loading } = useSelector(
    (state) => state.loader
  )

  useEffect(() => {
    document.body.classList.toggle('prediction-market-open', isPredictionMarket)
    return () => document.body.classList.remove('prediction-market-open')
  }, [isPredictionMarket])

  return (
    <>
      <Header />
      <OnramperWidget />
      {loading && <Loader variant={LOADER_HANDLER_TYPES.submit} />}
      <Suspense fallback={<Loader variant={LOADER_HANDLER_TYPES.submit} />}>
        <Switch>
          {
            routes.map((route) => (
              <Route
                path={route.path}
                key={route.path}
                exact
                render={() => <RouteValidator route={route} />}
              />
            ))
          }
          <Route component={() => <NotFoundComponent />} />
        </Switch>
      </Suspense>
    </>
  )
}

export default CustomRoutes
